import { defineComponent as _defineComponent } from 'vue'
import { isEmpty } from 'lodash';
import { computed } from 'vue';
import { StyleValue } from 'vue/types/jsx';
import { T_JJTooltip_Kink } from './JJTooltip.types';


export default /*#__PURE__*/_defineComponent({
  __name: 'JJTooltip',
  props: {
    content: null,
    infoStyle: null,
    kind: null
  },
  setup(__props: any) {

const props = __props as {
    content?: string,
    infoStyle?: StyleValue
    kind?: T_JJTooltip_Kink
}



const iconStyle = computed(() => {
    const {
        infoStyle,
        kind,
    } = props
    let style: StyleValue = {
        fontSize: '14px',
        marginLeft: '4px',
        marginTop: '8px'
    }
    if (kind == 'ext') {
        style = {
            marginLeft: '4px'
        }
    }
    if (!isEmpty(infoStyle)) {
        style = infoStyle
    }
    return style
})



return { __sfc: true,props, iconStyle }
}

})